module.exports = __webpack_public_path__ + "static/media/bimbingan_konseling.811463ca.png";